/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // SUMMARY View Model
    // Holds the Final Summary for 
    // the application
    /**************************************/
    function SummaryViewModel() {

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.BasicPersonData = ko.observable(new sm.portal.vm.PersonalInformationViewModel());
        this.BasicContactData = ko.observable(new sm.portal.vm.BasicContactViewModel());
        this.AcademicData = ko.observable(new sm.portal.vm.AcademicInterestsViewModel());
        this.DemographicData = ko.observable(new sm.portal.vm.DemographicViewModel());
        this.ConservatoireSpecialismsData = ko.observable(new sm.portal.vm.ConservatoireSpecialismsViewModel());
        this.LanguagesData = ko.observable(new sm.portal.vm.LanguagesViewModel());
        this.AccessibilityNeedData = ko.observable(new sm.portal.vm.AccessibilityNeedViewModel());
        this.EmploymentData = ko.observable(new sm.portal.vm.EmploymentViewModel());
        this.CollegeData = ko.observable(new sm.portal.vm.PreviousCollegeViewModel());
        this.HighSchoolData = ko.observable(new sm.portal.vm.PreviousHighSchoolViewModel());
        this.QualificationsOnEntryData = ko.observable(new sm.portal.vm.QualificationsOnEntryViewModel());
        this.ApplicationInformationData = ko.observable(new sm.portal.vm.ApplicationInformationViewModel());
        sm.portal.vm.custom.callCustomization('UpdateSummaryViewModel', self);
        this.TestScoreData = ko.observable(new sm.portal.vm.PlacementTestViewModel());
        this.DocumentsData = ko.observable();
        this.PaymentData = ko.observable();
        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("SummaryContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        /*** COMPUTED PROPERTIES ***/
        this.BasicPersonTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('BasicPerson');
        });
        this.BasicContactTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('BasicContact');
        });
        this.AcademicTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Academic');
        });
        this.DemographicTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Demographic');
        });
        this.ConservatoireSpecialismsTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('ConservatoireSpecialisms');
        });
        this.LanguagesTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Languages');
        });
        this.AccessibilityNeedTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('AccessibilityNeed');
        });
        this.EmploymentTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Employment');
        });
        this.CollegeTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('College');
        });
        this.HighSchoolTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('HighSchool');
        });
        this.QualificationsTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('QualificationsOnEntry');
        });
        this.ApplicationInformationTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('ApplicationInformation');
        });
        this.TestScoreTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('TestScore');
        });
        this.DocumentsTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Documents');
        });
        this.PaymentTitle = ko.computed(function () {
            return viewModel.GetSectionTitle('Payment');
        });
        this.Completed = ko.computed(function () {

            var isCompleted = false;
            return isCompleted;

        }, this);

        this.IsAnyCollegeGoal = ko.computed(function () {
            var result = false;

            if (this.CollegeData() && this.CollegeData().DataList()) {
                ko.utils.arrayForEach(this.CollegeData().DataList(), function (data) {
                    if (data.EducationalGoal()) {
                        result = true;
                    }
                });
            }

            return result;
        }, this);

        this.GetAcademicStartPeriodLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AcademicStartPeriodLabel === 'undefined') {
                return "AcademicStartPeriod";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AcademicStartPeriodLabel();
            }
        }
        this.GetDeliveryMethodLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.DeliveryMethodLabel === 'undefined') {
                return "DeliveryMethod";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.DeliveryMethodLabel();
            }
        }
        this.GetCampusLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.CampusLabel === 'undefined') {
                return "Campus";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.CampusLabel();
            }
        }
        this.GetAcademicLevelLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AcademicLevelLabel === 'undefined') {
                return "AcademicLevel";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AcademicLevelLabel();
            }
        }
        this.GetApplicationGoalLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ApplicationGoalLabel === 'undefined') {
                return "ApplicationGoal";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ApplicationGoalLabel();
            }
        }
        this.GetProgramRouteLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ProgramRouteLabel === 'undefined') {
                return "AdmissionsProgramOfferingItem";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ProgramRouteLabel();
            }
        }
        this.GetAdmissionsProgramLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AdmissionsProgramLabel === 'undefined') {
                return "AdmissionsProgram";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AdmissionsProgramLabel();
            }
        }
        this.GetInitialEnrollmentLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.InitialEnrollmentLabel === 'undefined') {
                return "InitialEnrollmentStatus";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.InitialEnrollmentLabel();
            }
        }
        this.GetExpectedEnrollmentLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ExpectedEnrollmentLabel === 'undefined') {
                return "ExpectedEnrollmentLabel";
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ExpectedEnrollmentLabel();
            }
        }
        this.GetAttendanceTypeLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AttendanceTypeText === 'undefined') {
                return this.AcademicData().UpdateTemplateProperties.AttendanceTypeLabel();
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AttendanceTypeText();
            }
        }
        this.GetAttendanceReasonLabel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AttendanceReasonText === 'undefined') {
                return this.AcademicData().UpdateTemplateProperties.AttendanceReasonLabel();
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AttendanceReasonText();
            }
        }
        this.ShowHideAcademicStartPeriod = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AcademicStartPeriodVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AcademicStartPeriodVisible();
            }
        }
        this.ShowHideAcademicLevel = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AcademicLevelVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AcademicLevelVisible();
            }
        }
        this.ShowHideApplicationGoal = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ApplicationGoalVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ApplicationGoalVisible();
            }
        }
        this.ShowHideAdmissionsProgram = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AdmissionsProgramVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AdmissionsProgramVisible();
            }
        }
        this.ShowHideDeliveryMethod = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.DeliveryMethodVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.DeliveryMethodVisible();
            }
        }
        this.ShowHideProgramRoute = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ProgramRouteVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ProgramRouteVisible();
            }
        }
        this.ShowHideCampus = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.CampusVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.CampusVisible();
            }
        }
        this.ShowHideInitialEnrollment = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.InitialEnrollmentVisible === 'undefined') {
                return !this.AcademicData().UpdateTemplateProperties.HideAdmissionsType();
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.InitialEnrollmentVisible();
            }
        }
        this.ShowHideExpectedEnrollment = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.ExpectedEnrollmentVisible === 'undefined') {
                return !this.AcademicData().UpdateTemplateProperties.HideAdmissionsType();
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.ExpectedEnrollmentVisible();
            }
        }
        this.ShowHideAttendanceType = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AttendanceTypeVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AttendanceTypeVisible();
            }
        }
        this.ShowHideAttendanceReason = function () {
            if (typeof this.AcademicData().UpdateTemplateProperties.AttendanceReasonVisible === 'undefined') {
                return true;
            }
            else {
                return this.AcademicData().UpdateTemplateProperties.AttendanceReasonVisible();
            }
        }


        /*** COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.LoadSection = function (sectionID, data) {

            try {
                eval('this.' + sectionID + 'Data(data);');
            } catch (e) { }
        }
        this.LoadModel = function (container) {

            this.DataLoading(false);
            this.DataLoaded(false); // Always keep this current.    
            if (smapi.constant.applicationDebugFlag) { console.log('[SummaryVM] Data Loaded'); }
            sm.portal.vm.custom.callCustomization('UpdateLoadSummarySectionVM', self);
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);
                viewModel.LoadSummaryData();

                if (blockui) { self.BlockContainer(); }

                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=summary&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                        if (data.Status == 'success') {
                            // update application section configurations
                            if (container && container.Payload && container.Payload.Config) {
                                viewModel.SetSectionsConfigData("Summary", container.Payload.Config);
                            }
                        }
                        callback && callback(data);
                        self.UnBlockContainer();
                    },
                    error: function (jqXHR, exception) {
                        self.UnBlockContainer();
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Submitting') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
        };
        /*** SECTION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        SummaryViewModel: SummaryViewModel,
    });

})(jQuery);